import axios from "axios";

const environment = process.env.REACT_APP_BACKEND_URL;

const axiosInstance = axios.create({
    baseURL: environment,
    headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json, text/plain, */*",
    },
});

axiosInstance.defaults.headers.common["x-session-verify"] = localStorage.getItem("session_active");
axiosInstance.defaults.headers.common["X-Access-From-Browser"] = "frontend-login";

// Make sure every requests uses the expected x-session-verify
// If the browser has multiple tabs open, the backend will process multiple AUTH_COOKIE. Since we
// only store one AUTH_COOKIE, only the last one will be the valid one. At every request, make sure
// to use tha latest cookie
axiosInstance.interceptors.request.use(
    (config) => {
        // Get the latest token from local storage
        const sessionToken = localStorage.getItem("session_active");

        // If the token exists, add it to the headers
        if (sessionToken) {
            config.headers["x-session-verify"] = sessionToken;
        }

        // Return the updated config
        return config;
    },
    (error) => {
        console.error(`Error setting headers: ${error}`);
        return Promise.reject(error);
    }
);

export {axiosInstance, environment};
